import { Mail } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { associationEmail } from '../contactData';

export const ShopDialog = ({ product, onClose }) => {
  const mailto = product && associationEmail
    ? `mailto:${associationEmail}?subject=${encodeURIComponent(`Fantasti100 — Merch: ${product.name}`)}&body=${encodeURIComponent(`Ciao! Vorrei informazioni su: ${product.name} (colori, taglie e disponibilità).\n\n`)}`
    : null;
  return <Dialog open={!!product} onOpenChange={(open) => { if (!open) onClose(); }}>
    <DialogContent className="shop-dialog editorial-dialog" data-testid="shop-dialog" data-lenis-prevent>
      {product && <div className="shop-dialog-grid">
        <div className="shop-dialog-media"><img src={product.image} alt={product.name} /></div>
        <div className="shop-dialog-info">
          <span className="eyebrow" data-testid="shop-dialog-type">{product.type}</span>
          <DialogTitle className="dialog-heading" data-testid="shop-dialog-title">{product.name}</DialogTitle>
          <DialogDescription data-testid="shop-dialog-description">{product.description}</DialogDescription>
          <div className="shop-spec" data-testid="shop-dialog-colors">
            <span className="shop-spec-label">Colori disponibili</span>
            <div className="shop-colors">{product.colors.map(color => <span key={color.name} className="shop-swatch" style={{ background: color.hex }} title={color.name} />)}</div>
          </div>
          <div className="shop-spec" data-testid="shop-dialog-sizes">
            <span className="shop-spec-label">Taglie disponibili</span>
            <div className="shop-sizes">{product.sizes.map(size => <span key={size} className="shop-size">{size}</span>)}</div>
          </div>
          <div className="shop-contact" data-testid="shop-contact-note">
            <p>Vetrina non acquistabile online. Per info, colori e disponibilità scrivici via email:</p>
            {mailto
              ? <a className="button button-gold shop-whatsapp" href={mailto} data-testid="shop-contact-email"><Mail size={19} /> Scrivici via email</a>
              : <p className="shop-contact-pending" data-testid="shop-contact-email-pending">Indirizzo email in fase di attivazione.</p>}
          </div>
        </div>
      </div>}
    </DialogContent>
  </Dialog>;
};
